// Birthday-riso — variant. Renders /templates/birthday-riso.html
// (Risograph print-style birthday template, paper + bold orange + ink,
// Cormorant Garamond display + JetBrains Mono captions) inside a
// full-bleed iframe. This is a designer showcase template without a
// query-string customizer — params are passed through for forward
// compatibility so we can wire one up later without touching this file.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/birthday-riso.html";

export function BirthdayRisoStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  // Birthday: a single name (no "&"), but we still pass via "names".
  if (t.names) params.set("names", t.names.split(/\s*&\s*/)[0].trim());
  if (t.date) {
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (ctx.slug) params.set("slug", ctx.slug);
  params.set("v", "2");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;
  return (
    <iframe
      src={src}
      title={t.names || "Birthday Riso"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#F2EBDC",
      }}
    />
  );
}
